import React, { Fragment } from "react";
import GiftCertificatesPopup from "../../VagaroComponent/GCPopup";
import ReactDom from "react-dom";
import { UserContext } from "../Definitions/UserContext";
import { addtoCartEnum, utils } from "../../utils/Utils";
import OopsBanner, { NoRecordsBanner } from "../OopsBanner";
import { getClustorBusinessData } from "../Utilities/BusinessData";
import Loader from "../Common/Loader";

export default function RenderBusinessGiftCards({ data, layout, userContext, allowMultiLoc }: { data: any, layout: string, userContext: UserContext, allowMultiLoc: boolean }) {

    const [isAddCartLoading, setIsAddCartLoading] = React.useState(false);

    if (data == null) return <OopsBanner />;

    if (data.length == 0) {
        return <NoRecordsBanner message='No gift certificates available.' />
    }

    const showcartLoader =  (isLoading:any) => {
        setIsAddCartLoading(isLoading);
    }

    switch (layout) {
        default:
            return <Fragment>{isAddCartLoading && <Loader/>}<RenderDefaultLayout data={data} userContext={userContext} allowMultiLoc={allowMultiLoc} addTocartLoader={(res:any) => showcartLoader(res)} /></Fragment>
    }
}

function RenderDefaultLayout({ data, userContext, allowMultiLoc, addTocartLoader }: { data: any, userContext: UserContext, allowMultiLoc: boolean, addTocartLoader:Function }) {

    const isStenciled = data[0]?.isStenciled === true;

    const rows = [];
    for (let i = 0; i < data.length; i += 3) {
        const row = [];
        for (let j = 0; j < 3; j++) {
            if (data[i + j])
                row.push(data[i + j]);
            else {
                row.push({ photo: "" });
            }
        }
        rows.push(row);
    }

    return <>        
         <div className="gift-certificate-contianer">
            
        {/*Per design team we are not including any labels/headings inside components to allow users to phrase it themselves 
        <div className="" role="contentinfo" aria-label="There are Different types of Gift Certificates available in Vagaro. Please Select Category For Gift Certificate"><h3 className="gctitle-comp">Select a Category</h3></div> */}
        <div className={"flex-row flex-wrap resizable-container align-start w-full max-100 gc-cards-grid" + (isStenciled ? "stenciled" : "")} style={{ gap: "inherit" }}>
            {data.map((giftCard: any, index: number) => { return <RenderGiftCard key={index} giftCard={giftCard} userContext={userContext} isStencil={isStenciled} allowMultiLoc={allowMultiLoc} addTocartLoader={(res:any) => addTocartLoader(res)} /> })}
        </div>
        </div>
    </>

}


function RenderGiftCard({ giftCard, userContext, isStencil, allowMultiLoc, addTocartLoader }: { giftCard: any, userContext: UserContext, isStencil?: boolean, allowMultiLoc: boolean, addTocartLoader: Function }) {
    

    
    
    const isEditor = (window as any).isEditor !== undefined ? (window as any).isEditor : false
    if (!giftCard.photo)
        giftCard.photo = "";
    if (!giftCard.giftCertificateCatName)
        giftCard.giftCertificateCatName = "";
    if(giftCard.giftCertificateCatName=="Business Created")
        giftCard.giftCertificateCatName = "Branded";

    return (
        <>
            <div id={'gcpopup' + giftCard.giftCertificateCatIds} className="gift-card quarter-third-half-full" onClick={(event) => !isEditor && GCPopup(giftCard, userContext, event, allowMultiLoc, (response:any)=> addTocartLoader(response))}>
                <div className="inner-gift-card stencil-item" style={{ width: "100%", backgroundImage: `url(${giftCard.photo})`, backgroundPosition: "center", backgroundSize: "cover", position: "relative" }}>
                    <div className="gift-card-text center-all w-full stencil-item vp-1 " style={{ fontSize: "1.5em", position: "absolute", textAlign: "center", bottom: "0px", background: "linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.6))", color: "white", height: "auto", paddingBottom: "10px",margin:"0px" }} >
                        {giftCard.giftCertificateCatName}</div>
                </div>

            </div>
        </>

    )

}

function GCPopup(giftCard: any, userContext: UserContext, event: any, allowMultiLoc: boolean, addTocartLoader: Function) {
    var LoginDetails = utils.ReadCookie();
    if (LoginDetails === undefined || LoginDetails === "" || LoginDetails === null) {
        window.wbc.openVagaroPage("divVagaroIframe", utils.VURL("Login", null) + addtoCartEnum.GCAddToCart + "&Data=" + event.currentTarget.id);
        return;
    }
    const BusinessData = utils.MultiLocationData(userContext, userContext.bidHash);
    if(giftCard.isGroupMysite) {
        addTocartLoader(true);
        getClustorBusinessData(userContext, "GiftCertificate", "", "", giftCard.multiGroupGC, (data:any)=>{
            addTocartLoader(false);
            if (data != null && data.data != null && data.data.data != null) {
                giftCard.multiGroupGC = data.data.data;
            }
            return ReactDom.render(
                <GiftCertificatesPopup giftCard={giftCard} userContext={userContext} businessData={BusinessData} LoginDetails={LoginDetails} allowMultiLoc={allowMultiLoc} />,
                document.getElementById("OpenDialog")
            );
        },()=>{})
    }
    else {        
        return ReactDom.render(
            <GiftCertificatesPopup giftCard={giftCard} userContext={userContext} businessData={BusinessData} LoginDetails={LoginDetails} allowMultiLoc={allowMultiLoc} />,
            document.getElementById("OpenDialog")
        );
    }
}